module.exports = __webpack_public_path__ + "static/media/icon-cooking.4e116a6d.svg";